import { InternalNetworkContract } from '@terra/shared-contracts-internal-network';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const internalNetworkClient = createTerraOrpcClient({
  contract: InternalNetworkContract,
  serviceName: SERVICE_NAME,
});
